import axios from 'axios'
import qs from 'qs'
import { apiConfig } from './apiConfig'
import { requestHandler, responseHandler } from './interceptors'

export function createInstance (config) {
  const instance = axios.create(config)
  if (!config.paramsSerializer) {
    config.paramsSerializer = params => {
     return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }
  return instance
}

var api = createInstance(apiConfig)
// add interceptors
for (const key in requestHandler) {
  if (requestHandler.hasOwnProperty(key)) {
    const { fulfilled, rejected } = requestHandler[key]
    api.interceptors.request.use(fulfilled, rejected)
  }
}
for (const key in responseHandler) {
  if (responseHandler.hasOwnProperty(key)) {
    const { fulfilled, rejected } = responseHandler[key]
    api.interceptors.response.use(fulfilled, rejected)
  }
}

export default api
